<template>
  <div class="position-relative">    
    <div class="d-flex justify-content-between align-items-center">
      <span class="soha-filter-title">{{ title }}</span>

      <Dropdown
        v-model="internalValue"
        :options="options"
        option-label="title"
        class="w-full md:w-14rem"
        size="large"
        @change="onChange"
      >
        <template #value="slotProps">
          <div v-if="slotProps.value">
            <span>{{ slotProps.value.title }}</span>
          </div>
          <span v-else>
            {{ slotProps.placeholder }}
          </span>
        </template>
      </Dropdown>
    </div>
  </div>
</template>

<script>
import Dropdown from 'primevue/dropdown';

export default {
  name: "SohaOrderSelection",

  components: {
    Dropdown,
  },

  props: {
    title: {
      type: String,
      required: true,
    },
    modelValue: {
      type: [Number, String, Object],
      default: null,
    },
    options: {
      type: Array,
      required: true,
    },
  },

  emits: ['update:modelValue', 'change'],

  data() {
    return {
      internalValue: null,
    };
  },

  watch: {
    modelValue: {
      immediate: true,
      handler(newVal) {
        const correspondingOption = this.options.find(opt => 
          opt.id === newVal || opt.value === newVal
        );
        this.internalValue = correspondingOption || newVal;
      }
    },

    internalValue(newVal) {
      // وقتی internalValue تغییر کرد، modelValue رو آپدیت کن
      if (newVal && typeof newVal === 'object') {
        this.$emit('update:modelValue', newVal || newVal.value);
      } else {
        this.$emit('update:modelValue', newVal);
      }
    }
  },

  methods: {
    onChange(selectedOption) {
      // selectedOption می‌تونه object کامل باشه یا فقط value
      if (selectedOption && typeof selectedOption === 'object') {
        this.$emit('update:modelValue', selectedOption.id || selectedOption.value);
        this.$emit('change', selectedOption);
      } else {
        this.$emit('update:modelValue', selectedOption);
        this.$emit('change', selectedOption);
      }
    },
  },
};
</script>

<style scoped>
.soha-filter-title {
  border: 0.038rem solid var(--box-border-color);
  padding: 0.625rem;
  position: absolute;
  right: -10.5rem;
  z-index: 1;
  background: white;
  border-top-right-radius: 0.6rem;
  border-bottom-right-radius: 0.6rem;
  background: rgb(244, 251, 255);
}
</style>